/** @format */

import React, { useState } from "react";

import Pagination from "../../../../components/common/Pagination";
import TableBody from "./TableBody";
import TableHeader from "./TableHeader";

const Table = ({ arrays, showActions, onProfileClick }) => {
  const [activeTab, setActiveTab] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Number of items to display per page

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setCurrentPage(1); // Reset current page when changing tabs
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const filterRowsByStatus = (status) => {
    if (status === "all") {
      return arrays;
    } else {
      return arrays.filter((row) => row.Status.toLowerCase() === status);
    }
  };

  const filteredRows = filterRowsByStatus(activeTab);

  // Calculate pagination values
  const lastIndex = currentPage * itemsPerPage;
  const firstIndex = (currentPage - 1) * itemsPerPage;

  const currentItems = filteredRows.slice(firstIndex, lastIndex);
  const totalPages = Math.ceil(filteredRows.length / itemsPerPage);

  const allCount = arrays.length;
  const approvedCount = arrays.filter(
    (row) => row.Status.toLowerCase() === "approved"
  ).length;
  const pendingCount = arrays.filter(
    (row) => row.Status.toLowerCase() === "pending"
  ).length;
  const unapprovedCount = arrays.filter(
    (row) => row.Status.toLowerCase() === "disapproved"
  ).length;

  return (
    <div className="overflow-x-auto px-5">
      {/* Tabs */}
      <div className="mb-4">
        <ul className="flex flex-wrap font-medium text-center text-gray-500">
          <li className="mr-2" role="presentation">
            <button
              className={`inline-block p-3 border-b-2  ${
                activeTab === "all"
                  ? "border-blue-500 text-black"
                  : "border-transparent"
              }`}
              type="button"
              onClick={() => handleTabChange("all")}
            >
              All ({allCount})
            </button>
          </li>
          <li className="mr-2" role="presentation">
            <button
              className={`inline-block p-3 border-b-2 ${
                activeTab === "approved"
                  ? "border-blue-500 text-black"
                  : "border-transparent"
              }`}
              type="button"
              onClick={() => handleTabChange("approved")}
            >
              Mine ({approvedCount})
            </button>
          </li>
          <li className="mr-2" role="presentation">
            <button
              className={`inline-block p-3 border-b-2 ${
                activeTab === "pending"
                  ? "border-blue-500 text-black"
                  : "border-transparent"
              }`}
              type="button"
              onClick={() => handleTabChange("pending")}
            >
              Pending Review ({pendingCount})
            </button>
          </li>
          <li role="presentation">
            <button
              className={`inline-block p-3 border-b-2 ${
                activeTab === "disapproved"
                  ? "border-blue-500 text-black"
                  : "border-transparent"
              }`}
              type="button"
              onClick={() => handleTabChange("disapproved")}
            >
              Closed ({unapprovedCount})
            </button>
          </li>
        </ul>
      </div>

      <div className=" ">
        <table className="table-auto w-full mt-5  mb-5 rounded-lg font-Inter">
          <TableHeader showActions={showActions} />
          <TableBody
            rows={currentItems}
            firstIndex={firstIndex}
            showActions={showActions}
            onProfileClick={onProfileClick}
          />
        </table>
      </div>

      <Pagination
        totalPages={totalPages}
        activePage={currentPage}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default Table;
